//
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React from 'react'
import Cookies from 'universal-cookie'

//
// ─── IMPORTING UTILS ───────────────────────────────────────
//
import { timeStamp } from '../../../../contexts/Utils'
import Button from '../../../Button'

// SCSS
import './ModalScanConfirmation.scss'

//
// ─── FORMATAGE DE LA DATE ───────────────────────────────────────
//
const formatScanDate = (value) => {
  const date = new Date(String(value).replace(' ', 'T'))
  if (isNaN(date.getTime())) return ''

  return date.toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

//
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const ModalScanConfirmation = ({ open, scan, onClose }) => {
  // Cookies
  const cookies = new Cookies();
  const userData = cookies.get(process.env.REACT_APP_USER_COOKIE);

  //
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <div className={`modal-container two ${open ? '' : 'out'}`}>
    <div className="modal-background">
      <div className="modalScanConfirmation">
        <div className='user_image'>
          <img loading="lazy" src={`${process.env.REACT_APP_URL}/img/users/${userData.user_id}/${userData.thumbnail}?${timeStamp()}`} alt={userData.name} />
        </div>
        <div className='userInfosModal'>
          <h3 className='nameUser'>{userData.name}</h3>
          <h2 className='firstNameUser'>{userData.firstname}</h2>
          <p className='reduction'>30%</p>
          <p className='reductionText'>valable sur place ou à emporter</p>
        </div>
        <div className='scanInfos'>
          <p className='storeName'>{scan.store_name}</p>
          <p className='scanDate'>{formatScanDate(scan.time_create)}</p>
        </div>
        <p className='scanHint'>Présentez cet écran au caissier.</p>
        <Button className="button secondary" text='Fermer' onClick={onClose} />
      </div>
    </div>
  </div>
}

export { formatScanDate }
export default ModalScanConfirmation;
